import React from 'react';
import { Alert } from '@printdeal/ui-library';
import { FormattedMessage } from 'react-intl';
import { useLocation } from '@gatsbyjs/reach-router';
// @ts-expect-error
import { messages } from '../../translations/orders';
import { Location } from '../../../../types/Location';

const PaymentAlert = () => {
  const location = useLocation() as Location;
  if (!location || !location.state || !location.state.adyenAuthResult) {
    return null;
  }
  return (
    <Alert className="pd-mb-3" variant={messages[location.state.adyenAuthResult].type} isDismissible>
      <FormattedMessage id={messages[location.state.adyenAuthResult].id} />
    </Alert>
  );
};

export default PaymentAlert;
